import React from 'react';
import { Box } from '@mui/system';
import AccessDataProvider from './contextProviders/AccessDataContext';
import './App.scss';
import SiteContent from './pages/SiteContent';
import OverlayProvider from './contextProviders/OverlayContext';

function App() {
  return (
    <Box>
      <OverlayProvider>
        <AccessDataProvider>
          <SiteContent />
        </AccessDataProvider>
      </OverlayProvider>
    </Box>
  );
}

export default App;
